import { flow, makeObservable, observable } from "mobx";
import { NotificationStoreInstance } from "@common/stores";
import { VetScheduleRequest } from "@common/models/requests/VetScheduleRequest";
import { VeterinarianModel } from "@common/models";
import { VeterinarianService } from "@common/services";


export class VeterinarianStore {
    @observable veterinarian?: VeterinarianModel = undefined;
    @observable loading: boolean = false;

    constructor() {
        makeObservable(this, undefined, { autoBind: true });
    }

    fetchVeterinarianByVetId = flow(function* (this: VeterinarianStore, vetId: number): Generator<Promise<any>, void, any> {
        this.loading = true;

        this.veterinarian = yield VeterinarianService.getVeterinarianByVetId(vetId)
            .catch(NotificationStoreInstance.onError("Failed to fetch vet record.", undefined));

        this.loading = false;
    });

    fetchVeterinarianByUserId = flow(function* (this: VeterinarianStore, userId: number): Generator<Promise<any>, void, any> {
        this.loading = true;

        this.veterinarian = yield VeterinarianService.getVeterinarianByUserId(userId)
            .catch(NotificationStoreInstance.onError("Failed to fetch vet record.", undefined));

        this.loading = false;
    });

    saveSchedulePreferences = flow(function* (this: VeterinarianStore, request: VetScheduleRequest): Generator<Promise<any>, void, any> {
        if (!this.veterinarian) return;
        this.loading = true;

        this.veterinarian = yield VeterinarianService.saveSchedulePreferences(this.veterinarian.veterinarianId, request)
            .catch(NotificationStoreInstance.onError("Failed to update schedule preferences.", this.veterinarian));

        this.loading = false;
    });
}
